import React, { FC } from 'react';
import {
  Bar,
  BarChart,
  CartesianGrid,
  Cell,
  LabelList,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { ISurveyResponse } from '../../shared/interfaces/ISurveyResponse';
import useChartData from '../../hooks/useCalculateChartData';

interface IRechartData {
  surveyResponse: ISurveyResponse[];
  type: string;
  mode: string;
}

const ChartComponent: FC<IRechartData> = ({ surveyResponse, type, mode }) => {
  const chartData = useChartData(surveyResponse, type, mode);

  return (
    <ResponsiveContainer
      width="100%"
      height="100%"
    >
      <BarChart
        width={500}
        data={chartData}
        barSize={40}
        margin={{
          top: 20,
          right: 30,
          left: 20,
          bottom: 5,
        }}
      >
        <XAxis
          dataKey="name"
          scale="point"
          padding={{ left: 80, right: 80 }}
        />
        <YAxis />
        <Tooltip />
        <CartesianGrid
          strokeDasharray="3 3"
          vertical={false}
        />
        <Bar
          dataKey="surveys"
          radius={[4, 4, 0, 0]}
          background={{ fill: 'rgba(238,238,238,0.3)' }}
        >
          {chartData.map((entry, index) => (
            <Cell
              key={`cell-${index}`}
              fill={entry.color}
            />
          ))}
          <LabelList
            dataKey="surveys"
            position="top"
            fill="#000"
            style={{ fontWeight: 'bold' }}
          />
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};

export default ChartComponent;
